// Date / number helpers used by document templates.

export function parseDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const ONES = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen",
];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function lessThan100(n) {
  if (n < 20) return ONES[n];
  const a = Math.floor(n / 10);
  const b = n % 10;
  return b ? `${TENS[a]} ${ONES[b]}` : TENS[a];
}

export function yearInWords(year) {
  if (!year || Number.isNaN(Number(year))) return "____________";
  const y = Number(year);
  if (y >= 2000 && y < 2100) {
    const rest = y - 2000;
    const tail = rest === 0 ? "" : ` ${lessThan100(rest)}`;
    return `Two Thousand${tail}`;
  }
  // Generic fallback
  return String(y);
}

export function formatDDMMYYYY(iso) {
  const d = parseDate(iso);
  if (!d) return "____________";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function getDayMonthYear(iso) {
  const d = parseDate(iso);
  if (!d) return { day: "____", month: "____________", yearWords: "____________" };
  return {
    day: String(d.getDate()),
    month: MONTHS[d.getMonth()],
    yearWords: yearInWords(d.getFullYear()),
  };
}

export function dash(v, ph = "____________") {
  return v && String(v).trim().length ? String(v) : ph;
}

/**
 * English ordinal suffix for a day-of-month value (1-31).
 * Returns "st", "nd", "rd" or "th" — including the special cases
 * 11/12/13 which always take "th".
 *
 * Used ONLY by the English Vakalatnama for the "N day of ..." line.
 * The Marathi Vakalatnama is intentionally NOT touched.
 */
export function englishOrdinalSuffix(day) {
  const n = parseInt(day, 10);
  if (!Number.isFinite(n)) return "";
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return "th";
  const mod10 = n % 10;
  if (mod10 === 1) return "st";
  if (mod10 === 2) return "nd";
  if (mod10 === 3) return "rd";
  return "th";
}

/* ============ Marathi helpers ============ */

const MR_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
const MR_MONTHS = [
  "जानेवारी", "फेब्रुवारी", "मार्च", "एप्रिल", "मे", "जून",
  "जुलै", "ऑगस्ट", "सप्टेंबर", "ऑक्टोबर", "नोव्हेंबर", "डिसेंबर",
];

export function toMarathiDigits(s) {
  return String(s ?? "").replace(/[0-9]/g, (d) => MR_DIGITS[Number(d)]);
}

// 2026-08-15  →  १५ ऑगस्ट २०२६
export function formatMarathiDate(iso) {
  const d = parseDate(iso);
  if (!d) return "____________";
  const day = toMarathiDigits(d.getDate());
  const month = MR_MONTHS[d.getMonth()];
  const year = toMarathiDigits(d.getFullYear());
  return `${day} ${month} ${year}`;
}

export function marathiYear(iso) {
  const d = parseDate(iso);
  if (!d) return "____";
  return toMarathiDigits(d.getFullYear());
}
